// TODO
import * as commonCookies from './app/constants/cookies';
export * from '@nuxt-common/media-card-large/config.mcom';
export * from '@nuxt-common/fulfillment/config.mcom';
export * from '@nuxt-common/locator/config.mcom';
export * from '@nuxt-common/product-quickview/config.mcom';
export * from './config.mcom.atb';
export * from './config.mcom.atr';
export * from './config.mcom.ppc';

const CUSTOMER_SERVICE_DOMAIN = 'https://www.macys.com/customer-service';

export const brand = 'mcom';
export const brandName = "Macy's";
export const marketPlace = {
  phoneNumber: '1-800-289-6229',
  concernReportLink: 'https://survey.medallia.com/?mcy-tuwyt-com',
  faqLink: '',
};
export const storeLocatorParams = {
  // for nearby stores
  storeLocationType: 'MSTORE', // 'BSTORE' for bcom and default 'UPS'
  divisionNumber: 12, // 12 for Macy's stores and 13 for Bloomingdale's stores,
  page: 'pdp',
};
export const denomination = [10, 25, 50, 75, 100, 500];
export const customerServiceUrls = {
  bigTicketShipping: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/articles/furniture-mattress-policies`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/furniture-mattress-policies`,
  },
  shipping: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/5363/theme/popup`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/what-are-my-delivery-shipping-options-at-macys/`,
  },
  returns: {
    international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/5362/theme/popup`,
    domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/what-is-macys-return-policy/`,
  },
  reviews: {
    termsOfUse: `${CUSTOMER_SERVICE_DOMAIN}/articles/legal-notice`,
    userGeneratedContent: `${CUSTOMER_SERVICE_DOMAIN}/articles/user-generated-content-policy`,
    contactUs: `${CUSTOMER_SERVICE_DOMAIN}/?cm_sp=navigation-_-bottom_nav-_-contact_us&lid=glbbtmnav_contact_us-us`,
  },
};
export const cookies = {
  ...commonCookies,
  userId: 'macys_online_uid',
  userGuid: 'macys_online_guid',
  bagGuid: 'macys_bagguid',
};
export const topLevelCategoryID = {
  men: '1',
  women: '118',
  junior: '16904',
  mattresses: '25931',
  comforters: '78458',
};
export const promotionalDetailsUrl = 'https://www.macys.com/s/promotional-details/journeysFS/';
export const promotionalDetailsUrlCommon = 'https://www.macys.com/s/free-shipping/#exclusions';
export const promotionalDetailsUrlGuest = 'https://www.macys.com/s/free-shipping/';
export const promotionalCreateProfile = '';
export const reviewsImgBaseUrl = 'https://slimages.macysassets.com/is/image/MCY/products/';
export const fulfillmentErrors = {
  SameDay: 'Not available for Same-Day Delivery',
  NextDay: 'Not available for Next-Day Delivery',
  Pickup: 'Not available for Pickup',
  ShipIt: 'Not available for Ship to Home',
};
export const wgdUnavailablePhoneNumber = '1-800-289-6229';
export const btAvailabilitySkeletonHeight = '20px';
